require('select2');

$('.select-multiple').select2({
    placeholder: "Select an option",
});

$('.modal').on('shown.bs.modal', function (e) {
    $(this).find('.select-multiple-modal').select2({
        dropdownParent: $(this).find('.modal-content')
    });
})